import type { IconSvgObject } from './types';

const LocationAdd02Icon: IconSvgObject = [
  ["path", { d: "M15.5 10.3887H12M12 10.3887H8.5M12 10.3887L12 13.8887M12 10.3887L12 6.88873", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2.38873C7.30558 2.38873 3.5 6.00659 3.5 10.4694C3.5 15.3299 8.21916 17.758 11.1092 21.1947C11.5669 21.739 12.4531 21.7534 12.9211 21.2179C15.8645 17.8501 20.5 15.2362 20.5 10.4694C20.5 6.00659 16.6944 2.38873 12 2.38873Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationAdd02Icon;
